import { useQuery, useMutation, useQueryClient } from 'react-query'
import {
  getUsers,
  getUsersNoPag,
  getOneUser,
  createUser,
  updateUser,
  updateUserProfile,
  deleteUser
} from '../api/users'

const getAction = (type) => {
  if (type === 'CREATE') return createUser
  if (type === 'UPDATE') return updateUser
  if (type === 'PROFILE') return updateUserProfile
  if (type === 'DELETE') return deleteUser
  return null
}

export function useUsers(page, formData, props = {}) {
  return useQuery(['users', page], () => getUsers(page, formData), {
    ...props,
    onError: (err) => {
      console.error(err.response)
    }
  })
}

export function useTechnicians(props = {}) {
  return useQuery(
    ['technicians'],
    async () => {
      const users = await getUsersNoPag()
      return { items: users.filter((user) => Number(user.id_role) === 2) }
    },
    {
      ...props,
      onError: (err) => {
        console.error(err.response)
      }
    }
  )
}

export function useUser(userId) {
  return useQuery(['user', userId], () => getOneUser(userId), {
    onError: (err) => {
      console.error(err.response)
    }
  })
}

export function useMutateUser(type) {
  const queryClient = useQueryClient()
  const actionFn = getAction(type)
  return useMutation(actionFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('user')
    },
    onError: (err) => {
      console.error(err.response)
    }
  })
}
